/**
 * Created by one on 16/9/11.
 */
export default {
  show (msg, delay = 2000) {
    this.remove()
    let alertDom = '<div id="js_cyzsAlertWrap">' +
      msg +
      '</div>'
    $('.page-wrapper').append(alertDom)
    var $alert = $('#js_cyzsAlertWrap')
    $alert.css({
      'color': '#fff',
      'background': 'rgba(0,0,0,0.7)',
      'border-radius': '4px',
      'position': 'fixed',
      'padding': '20px 10px',
      'left': '50%',
      'top': '50%',
      'z-index': 10000,
      'font-size': '18px',
      'display': 'none',
      'text-align': 'center'
    })
    $alert.css({
      'margin-left': (-($alert.outerWidth(true) / 2)) + 'px',
      'margin-top': (-($alert.outerHeight(true) / 2)) + 'px'
    })
    var that = this
    window.$alert = $alert
    $alert.fadeIn(1000)
    window.interval = setInterval(function () {
      window.$alert.fadeOut(1000, function () {
        that.remove()
      })
    }, delay)
  },
  remove () {
    if (window.$alert) {
      clearInterval(window.interval)
      window.$alert.remove()
      window.$alert = null
    }
  }
}
